import React, { FunctionComponent, useEffect, useState } from 'react';

import Errors from 'components/templates/Errors';
import { RecruitTemplateCodes, TemplateCodes } from 'navigations';
import Home from 'pages/Home';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { toggleLayout } from 'store/layout';
import { setPageTranslation } from 'store/system';

export type RenderPageProps = {
  pageData?: BasePageDataTypes<any>;
  isHome?: boolean;
};

const RenderPage: React.FC<RenderPageProps> = ({ pageData, isHome }) => {
  const dispatch = useAppDispatch();

  const layoutType = useAppSelector((state) => state.layout.layoutType);

  const [renderComponent, setRenderComponent] = useState<
  React.FC<BasePageDataTypes<any>> | undefined
  >();

  useEffect(() => {
    if (pageData) {
      // Translation
      let translation;
      if (pageData?.pageData.templateCode === 'HOME') {
        translation = pageData.pageData.translations?.map((item) => ({
          ...item,
          slug: '/',
        }));
      } else {
        translation = pageData.pageData.translations;
      }
      dispatch(setPageTranslation(translation));

      // Render
      const Component = TemplateCodes.find(
        (template) => template.code === pageData?.pageData.templateCode,
      )?.component;

      if (Component) {
        dispatch(toggleLayout('main-layout'));
        setRenderComponent(Component);
      } else {
        const RecruitComponent = RecruitTemplateCodes.find(
          (template) => template.code === pageData?.pageData.templateCode,
        )?.component;

        if (RecruitComponent) {
          dispatch(toggleLayout('recruit-layout'));
          setRenderComponent(RecruitComponent);
        } else {
          dispatch(toggleLayout('error'));
        }
      }
    }
  }, [pageData, dispatch]);

  if (!pageData) return null;

  if (isHome) {
    return <Home {...pageData} />;
  }

  if (renderComponent) {
    return React.createElement<BasePageDataTypes<any>>(
      renderComponent as FunctionComponent, pageData,
    );
  }

  if (layoutType === 'error') {
    return <Errors statusCode={404} />;
  }

  return null;
};

export default RenderPage;
